
export class PageTracker {
  private pageStartTime: number | null = null;
  private currentPageUrl: string | null = null;

  startPageTracking() {
    this.pageStartTime = Date.now();
    this.currentPageUrl = window.location.href;
  }

  getPageDuration(): number | null {
    if (!this.pageStartTime) return null;
    return Date.now() - this.pageStartTime;
  }

  getCurrentPageUrl(): string | null {
    return this.currentPageUrl;
  }

  clearPageTracking() {
    this.pageStartTime = null;
    this.currentPageUrl = null;
  }

  hasActivePageTracking(): boolean {
    return this.pageStartTime !== null && this.currentPageUrl !== null;
  }
}
